const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export const isDateOnlyString = (value: unknown): value is string =>
  typeof value === "string" && DATE_ONLY_PATTERN.test(value.trim());

const buildLocalDate = (year: number, month: number, day: number) =>
  // Use noon to avoid edge-case timezone shifts around midnight parsing.
  new Date(year, month - 1, day, 12, 0, 0, 0);

export const parseDateOnlyValue = (value: unknown): Date | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return buildLocalDate(
      value.getFullYear(),
      value.getMonth() + 1,
      value.getDate()
    );
  }

  if (isDateOnlyString(value)) {
    const [, year, month, day] = value.match(DATE_ONLY_PATTERN)!;
    return buildLocalDate(Number(year), Number(month), Number(day));
  }

  const parsed = new Date(value as string);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return buildLocalDate(
    parsed.getFullYear(),
    parsed.getMonth() + 1,
    parsed.getDate()
  );
};

export const formatDateOnlyValue = (value: unknown): string => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  if (isDateOnlyString(value)) {
    return value;
  }

  const parsed = parseDateOnlyValue(value);
  if (!parsed) {
    return "";
  }

  const year = parsed.getFullYear();
  const month = `${parsed.getMonth() + 1}`.padStart(2, "0");
  const day = `${parsed.getDate()}`.padStart(2, "0");

  return `${year}-${month}-${day}`;
};
